export const FEATURE_FLAGS = {
  prestige: false
} as const;
